
/*
Author: Tim Channell

These functions are list (Array) functions that I've mostly borrowed
from my experience with Haskell. Equivalents to many of them exist in JS
already, but some do not have full compatibility with all browsers

Here is a list of the known equivalents
    My function         Equivalent
    - foldl             array.reduce
    - foldr             array.reduceRight
    - map               array.map
    - filter            array.filter
 */

(function() {
  var List;

  List = exports;

  List.head = function(xs) {
    return xs[0];
  };

  List.tail = function(xs) {
    return xs.slice(1, +xs.length + 1 || 9e9);
  };

  List.init = function(xs) {
    return xs.slice(0, +(xs.length - 2) + 1 || 9e9);
  };

  List.last = function(xs) {
    return xs[xs.length - 1];
  };

  List.foldl = function(fn, acc, xs) {
    var x;
    acc = (function() {
      var j, len, results;
      results = [];
      for (j = 0, len = xs.length; j < len; j++) {
        x = xs[j];
        results.push(fn(acc, x));
      }
      return results;
    })();
    return acc;
  };

  List.reverse = function(xs) {
    return List.foldl((function(acc, x) {
      return [x].concat(acc);
    }), [], xs);
  };

  List.foldr = function(fn, acc, xs) {
    var ls, x;
    ls = List.reverse(xs);
    acc = (function() {
      var j, len, results;
      results = [];
      for (j = 0, len = ls.length; j < len; j++) {
        x = ls[j];
        results.push(fn(x, acc));
      }
      return results;
    })();
    return acc;
  };

  List.map = function(fn, xs) {
    var i, j, len, results, x;
    results = [];
    for (i = j = 0, len = xs.length; j < len; i = ++j) {
      x = xs[i];
      results.push(fn(x, i));
    }
    return results;
  };

  List.filter = function(pred, xs) {
    var j, len, results, x;
    results = [];
    for (j = 0, len = xs.length; j < len; j++) {
      x = xs[j];
      if (pred(x) === true) {
        results.push(x);
      }
    }
    return results;
  };

  List.retrieve = function(xs, item) {
    var key, val;
    for (key in xs) {
      val = xs[key];
      if (key.toLowerCase() === item.toLowerCase()) {
        return val;
      }
    }
  };

  return List;

}).call(this);
